import { sendGet, sendPost } from "./axios";

// eslint-disable-next-line import/prefer-default-export
export const getProfile = (payload: any) =>
  sendGet("/api-client/profile", payload);
